<template>
  <div>
    <el-tabs
    type="border-card"
    v-model="activeName"
    >
      <el-tab-pane
      label="查询"
      name="one"
      >
        <!-- 查询表单 -->
        <el-form
        ref="search_form"
        :model="search_form"
        label-width="100px"
        class="search_form"
        >
          <el-form-item label="单证号" prop="docNo">
            <el-input placeholder="单证号" v-model="search_form.docNo"></el-input>
          </el-form-item>
          <el-form-item label="操作人员" prop="operator">
            <el-input placeholder="操作人员" v-model="search_form.operator"></el-input>
          </el-form-item>
          <el-form-item label="仓库" prop="wareHouseId">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.wareHouseId"
            placeholder="请选择仓库"
            clearable
            filterable
            >
              <el-option
              v-for="item in wareHouseId_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户" prop="customerId">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.customerId"
            placeholder="请选择客户"
            clearable
            filterable
            >
              <el-option
              v-for="item in customerId_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品(FROM)" prop="fmSku">
            <el-input
            :readonly="true"
            placeholder="请选择产品"
            @click.native="from_sku"
            v-model="search_form.fmSku"></el-input>
          </el-form-item>
          <el-form-item label="产品(TO)" prop="toSku">
            <el-input
            :readonly="true"
            placeholder="请选择产品"
            @click.native="to_sku"
            v-model="search_form.toSku"></el-input>
          </el-form-item>
          <el-form-item label="事务时间从" prop="orderTime">
            <el-date-picker
            style="width: 100%;"
            v-model="search_form.orderTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator='到'
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            @change="order_time_change"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
            type="primary"
            icon="el-icon-search"
            @click="search_business"
            v-if="btn_permission.includes('wms:stock:inventoryWorkList')||btn_permission.includes('superAdmin')"
            >查询</el-button>
            <el-button
            icon="el-icon-close"
            @click="reset_business"
            v-if="btn_permission.includes('wms:stock:inventoryWorkList')||btn_permission.includes('superAdmin')"
            >重置</el-button>
          </el-form-item>
        </el-form>
        <!-- 选择产品弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="productVisible"
        title="选择产品"
        width="60%"
        >
          <el-form :inline="true">
            <el-form-item label="关键字">
              <el-input placeholder="物料编码/名称/原厂编码" v-model="productKey"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary">搜索</el-button>
            </el-form-item>
          </el-form>
          <!-- 产品列表 -->
          <el-table
          :data="product_data"
          highlight-current-row
          border
          max-height="400"
          @row-dblclick="db_product"
          >
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="sku"
            label="物料编码"
            ></el-table-column>
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="descrC"
            label="物料描述"
            ></el-table-column>
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="descrE"
            label="规格"
            ></el-table-column>
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="reservedField04"
            label="原厂编码"
            ></el-table-column>
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="skuGroup3"
            label="供应商"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="skuGroup4"
            label="存储"
            ></el-table-column>
          </el-table>
          <!-- 产品列表分页 -->
          <el-pagination
          style="margin: 10px auto;"
          background
          @size-change="product_size_change"
          @current-change="product_current_change"
          :current-page="product_current_page"
          :page-sizes="[10,15,20,25]"
          :page-size="product_page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="product_total"
          ></el-pagination>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane
      label="列表"
      name="two"
      >
        <!-- 库存事务列表 -->
        <el-table
        v-loading="list_loading"
        :data="list_data"
        highlight-current-row
        border
        max-height="400"

        >
          <el-table-column
          align="center"
          sortable
          prop="transactionId"
          label="事务编号"
          width="120px"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="codeNameC"
          label="事务类型"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="docNo"
          label="单证号"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="docLineNo"
          label="单证行号"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="docType"
          label="单据类型"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="status"
          label="事务状态"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="transactionTime"
          label="事务时间"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="docType"
          label="单据类型"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="fmCustomerId"
          label="FM客户编号"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="fmSku"
          label="FM产品"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="fmLotNum"
          label="FM批次"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="fmLocation"
          label="FM库位"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="fmLotAtt01"
          label="FM生产日期"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="fmLotAtt02"
          label="FM有效期/失效期"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="fmLotAtt03"
          label="FM入库日期"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="fmLotAtt04"
          label="FM产品批号"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="toCustomerId"
          label="TO客户编号"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="toSku"
          label="TO产品"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="toLotNum"
          label="TO批次"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="toLocation"
          label="TO库位"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="toLotAtt01"
          label="TO生产日期"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="toLotAtt02"
          label="TO有效期/失效期"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="toLotAtt03"
          label="TO入库日期"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="toLotAtt04"
          label="TO产品批号"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="operator"
          label="操作人员"
          ></el-table-column>
          <el-table-column align="center" fixed="right" label="操作">
            <template slot-scope="scope">
              <el-tag
              class="operate"
              type="success"
              effect="dark"
              @click="check_detail(scope.row)"
              v-if="btn_permission.includes('wms:stock:inventoryWorkDetail')||btn_permission.includes('superAdmin')"
              >查看明细</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <!-- 库存事务列表分页 -->
        <el-pagination
        style="margin: 10px auto;"
        background
        @size-change="business_size_change"
        @current-change="business_current_change"
        :current-page="business_current_page"
        :page-sizes="[10,15,20,25]"
        :page-size="business_page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="business_total"
        ></el-pagination>
        <!-- 库存事务详情弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="detailsVisible"
        title="库存事务详情"
        width="60%"
        >
          <el-form
          ref="details_form"
          :model="details_form"
          label-width="130px"
          class="details_form"
          :disabled="true"
          >
            <el-form-item label="事务编号">
              <el-input v-model="details_form.transactionId"></el-input>
            </el-form-item>
            <el-form-item label="事务类型">
              <el-input v-model="details_form.codeNameC"></el-input>
            </el-form-item>
            <el-form-item label="单证号">
              <el-input v-model="details_form.docNo"></el-input>
            </el-form-item>
            <el-form-item label="单证行号">
              <el-input v-model="details_form.docLineNo"></el-input>
            </el-form-item>
            <el-form-item label="单据类型">
              <el-input v-model="details_form.docType"></el-input>
            </el-form-item>
            <el-form-item label="事务状态">
              <el-input v-model="details_form.status"></el-input>
            </el-form-item>
            <el-form-item label="事务时间">
              <el-input v-model="details_form.transactionTime"></el-input>
            </el-form-item>
            <el-form-item label="操作人员">
              <el-input v-model="details_form.operator"></el-input>
            </el-form-item>
            <el-form-item label="仓库">
              <el-input v-model="details_form.wareHouseId"></el-input>
            </el-form-item>
            <el-divider content-position="left">FROM</el-divider>
            <el-form-item label="客户">
              <el-input v-model="details_form.fmCustomerId"></el-input>
            </el-form-item>
            <el-form-item label="产品">
              <el-input v-model="details_form.fmSku"></el-input>
            </el-form-item>
            <el-form-item label="批次">
              <el-input v-model="details_form.fmLotNum"></el-input>
            </el-form-item>
            <el-form-item label="库位">
              <el-input v-model="details_form.fmLocation"></el-input>
            </el-form-item>
            <el-form-item label="数量">
              <el-input v-model="details_form.fmQtyEach"></el-input>
            </el-form-item>
            <el-form-item
            v-show="item.status!=1"
            v-for="(item,index) in details_form.fm_batch_list"
            :key="index"
            :label="item.lotName">
              <el-input v-model="item.lotAtt"></el-input>
            </el-form-item>
            <el-divider content-position="left">TO</el-divider>
            <el-form-item label="客户">
              <el-input v-model="details_form.toCustomerId"></el-input>
            </el-form-item>
            <el-form-item label="产品">
              <el-input v-model="details_form.toSku"></el-input>
            </el-form-item>
            <el-form-item label="批次">
              <el-input v-model="details_form.toLotNum"></el-input>
            </el-form-item>
            <el-form-item label="库位">
              <el-input v-model="details_form.toLocation"></el-input>
            </el-form-item>
            <el-form-item label="数量">
              <el-input v-model="details_form.toQtyEach"></el-input>
            </el-form-item>
            <el-form-item
            v-show="item.status!=1"
            v-for="(item,index) in details_form.to_batch_list"
            :key="index+item"
            :label="item.lotName">
              <el-input v-model="item.lotAtt"></el-input>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    data() {
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        activeName:'one',
        //选择仓库下拉框
        wareHouseId_list:[],
        //选择客户下拉框
        customerId_list:[],
        //选择产品弹框
        product_from_to:true,
        productVisible:false,
        productKey:'',
        product_data:[],
        product_current_page:1,
        product_page_size:10,
        product_total:0,
        //查询表单
        search_form:{
          docNo:'',
          operator:'',
          wareHouseId:'',
          customerId:'',
          fmSku:'',
          toSku:'',
          orderTime:'',
          beginTime:'',
          endTime:'',
        },
        //查询表单时间范围
        pickerOptions:{
          shortcuts:[
            {
              text:'今天',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                picker.$emit('pick',[start,end])
              }
            },
            {
              text:'昨天',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                start.setTime(start.getTime()-3600*1000*24)
                picker.$emit('pick',[start,end])
              }
            },
            {
              text:'最近1周',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                start.setTime(start.getTime()-3600*1000*24*7)
                picker.$emit('pick',[start,end])
              }
            },
            {
              text:'最近2周',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                start.setTime(start.getTime()-3600*1000*24*14)
                picker.$emit('pick',[start,end])
              }
            },
            {
              text:'最近3周',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                start.setTime(start.getTime()-3600*1000*24*21)
                picker.$emit('pick',[start,end])
              }
            },
            {
              text:'最近1个月',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                start.setTime(start.getTime()-3600*1000*24*30)
                picker.$emit('pick',[start,end])
              }
            },
            {
              text:'最近2个月',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                start.setTime(start.getTime()-3600*1000*24*60)
                picker.$emit('pick',[start,end])
              }
            },
            {
              text:'最近3个月',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                start.setTime(start.getTime()-3600*1000*24*90)
                picker.$emit('pick',[start,end])
              }
            }
          ]
        },
        //库存事务列表
        list_data:[],
        //库存事务列表懒加载
        list_loading:false,
        row_business_now:{},
        business_current_page:1,
        business_page_size:10,
        business_total:0,
        //库存事务详情表单弹框
        detailsVisible:false,
        details_form:{
          transactionId:'',
          codeNameC:'',
          docNo:'',
          docLineNo:'',
          docType:'',
          status:'',
          transactionTime:'',
          operator:'',
          wareHouseId:'',
          fmCustomerId:'',
          fmSku:'',
          fmLotNum:'',
          fmLocation:'',
          fmQtyEach:'',
          fm_batch_list:[],
          toCustomerId:'',
          toSku:'',
          toLotNum:'',
          toLocation:'',
          toQtyEach:'',
          to_batch_list:[]
        }
      }
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //客户下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/user/select/customer'
      }).then(data=>{
        if(data.data.success==true){
          that.customerId_list=data.data.data
        }
      })
      //仓库下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/user/select/warehouse'
      }).then(data=>{
        if(data.data.success==true){
          that.wareHouseId_list=data.data.data
        }
      })
    },
    mounted() {

    },
    methods:{
      //选择产品弹框
      from_sku(){
        this.productVisible=true
        this.product_from_to=true
        //获取产品列表
        this.get_product()
      },
      to_sku(){
        this.productVisible=true
        this.product_from_to=false
        //获取产品列表
        this.get_product()
      },
      //获取产品列表
      get_product(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/wms/basSku/list',
          params:{
            page:that.product_current_page,
            limit:that.product_page_size,
            sku:that.productKey,
            customerId:'',
            activeFlag:'',
            descrC:'',
            reservedField04:''
          }
        }).then(data=>{
          if(data.data.success==true){
            that.product_data=data.data.data.list
            that.product_total=data.data.data.total
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //双击产品列表
      db_product(row,column,event){
        this.productVisible=false
        if(this.product_from_to==true&&this.search_form.toSku==''){
          this.search_form.fmSku=row.sku
          this.search_form.toSku=row.sku
        }else if(this.product_from_to==true&&this.search_form.toSku!=''){
          this.search_form.fmSku=row.sku
        }else if(this.product_from_to==false){
          this.search_form.toSku=row.sku
        }
      },
      //查询产品列表
      search_product(){
        this.product_current_page=1
        this.product_page_size=10
        //获取产品列表
        this.get_product()
      },
      //产品列表分页
      product_current_change(val){
        this.product_current_page=val
        //获取产品列表
        this.get_product()
      },
      product_size_change(val){
        this.product_page_size=val
        //获取产品列表
        this.get_product()
      },
      //事务时间范围change事件
      order_time_change(value){
        if(value!=null){
          this.search_form.beginTime=value[0]
          this.search_form.endTime=value[1]
        }else{
          this.search_form.beginTime=''
          this.search_form.endTime=''
        }
      },
      //获取库存事务列表
      get_business(){
        let that=this
        that.list_loading=true
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/wms/stock/inventoryWorkList',
          params:{
            page:that.business_current_page,
            limit:that.business_page_size,
            docNo:that.search_form.docNo,
            wareHouseId:that.search_form.wareHouseId,
            customerId:that.search_form.customerId,
            fmSku:that.search_form.fmSku,
            toSku:that.search_form.toSku,
            beginTime:that.search_form.beginTime,
            endTime:that.search_form.endTime,
            operator:that.search_form.operator
          }
        }).then(data=>{
          that.list_loading=false
          if(data.data.success==true){
            that.list_data=data.data.data.list
            that.business_total=data.data.data.total
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //查询表单
      search_business(){
        this.activeName='two'
        this.business_current_page=1
        this.business_page_size=10
        //获取库存事务列表
        this.get_business()
      },
      //重置查询表单
      reset_business(){
        this.$refs.search_form.resetFields()
        this.search_form.beginTime=''
        this.search_form.endTime=''
        this.business_current_page=1
        this.business_page_size=10
        //获取库存事务列表
        this.get_business()
      },
      //库存事务列表分页
      business_size_change(val){
        this.business_page_size=val
        //获取库存事务列表
        this.get_business()
      },
      business_current_change(val){
        this.business_current_page=val
        //获取库存事务列表
        this.get_business()
      },
      //获取批次属性列表
      get_batch(row){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/wms/orderBase/lot/'+row.fmCustomerId
        }).then(data=>{
          if(data.data.success==true){
            that.details_form.fm_batch_list=data.data.data
            that.details_form.to_batch_list=data.data.data
            that.details_form.fm_batch_list.forEach(item=>{
              that.$set(item,'lotAtt','')
            })
            that.details_form.to_batch_list.forEach(item=>{
              that.$set(item,'lotAtt','')
            })
            that.details_form.transactionId=row.transactionId
            that.details_form.codeNameC=row.codeNameC
            that.details_form.docNo=row.docNo
            that.details_form.docLineNo=row.docLineNo
            that.details_form.docType=row.docType
            that.details_form.status=row.status
            that.details_form.transactionTime=row.transactionTime
            that.details_form.operator=row.operator
            that.details_form.wareHouseId=row.wareHouseId
            that.details_form.fmCustomerId=row.fmCustomerId
            that.details_form.fmSku=row.fmSku
            that.details_form.fmLotNum=row.fmLotNum
            that.details_form.fmLocation=row.fmLocation
            that.details_form.fmQtyEach=row.fmQtyEach
            that.details_form.toCustomerId=row.toCustomerId
            that.details_form.toSku=row.toSku
            that.details_form.toLotNum=row.toLotNum
            that.details_form.toLocation=row.toLocation
            that.details_form.toQtyEach=row.toQtyEach
            that.details_form.fm_batch_list[0].lotAtt=row.fmLotAtt01
            that.details_form.fm_batch_list[1].lotAtt=row.fmLotAtt02
            that.details_form.fm_batch_list[2].lotAtt=row.fmLotAtt03
            that.details_form.fm_batch_list[3].lotAtt=row.fmLotAtt04
            that.details_form.fm_batch_list[4].lotAtt=row.fmLotAtt05
            that.details_form.fm_batch_list[5].lotAtt=row.fmLotAtt06
            that.details_form.fm_batch_list[6].lotAtt=row.fmLotAtt07
            that.details_form.fm_batch_list[7].lotAtt=row.fmLotAtt08
            that.details_form.fm_batch_list[8].lotAtt=row.fmLotAtt09
            that.details_form.fm_batch_list[9].lotAtt=row.fmLotAtt10
            that.details_form.fm_batch_list[10].lotAtt=row.fmLotAtt11
            that.details_form.fm_batch_list[11].lotAtt=row.fmLotAtt12
            that.details_form.to_batch_list[0].lotAtt=row.toLotAtt01
            that.details_form.to_batch_list[1].lotAtt=row.toLotAtt02
            that.details_form.to_batch_list[2].lotAtt=row.toLotAtt03
            that.details_form.to_batch_list[3].lotAtt=row.toLotAtt04
            that.details_form.to_batch_list[4].lotAtt=row.toLotAtt05
            that.details_form.to_batch_list[5].lotAtt=row.toLotAtt06
            that.details_form.to_batch_list[6].lotAtt=row.toLotAtt07
            that.details_form.to_batch_list[7].lotAtt=row.toLotAtt08
            that.details_form.to_batch_list[8].lotAtt=row.toLotAtt09
            that.details_form.to_batch_list[9].lotAtt=row.toLotAtt10
            that.details_form.to_batch_list[10].lotAtt=row.toLotAtt11
            that.details_form.to_batch_list[11].lotAtt=row.toLotAtt12
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //查看明细
      check_detail(row){
        this.detailsVisible=true
        //获取批次属性列表
        this.get_batch(row)
      }
    }
  }
</script>

<style scoped="scoped">
  /* 查询表单 */
  .search_form .el-form-item{
    width: 49%;
    display: inline-block;
  }
  .details_form .el-form-item{
    width: 32%;
    display: inline-block;
  }
  @media screen and (max-width:720px) {
    .search_form .el-form-item{
      width: 100%;
    }
    .details_form .el-form-item{
      width: 49%;
    }
  }
  .operate{
    cursor: pointer;
  }
  .search_form .el-form-item:last-child{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/store/business.vue